import loadScript from "./loadScript";

var toWxShareUrl = 'https://wapapi.nfnews.com/nfplus-wap-api/wx/getShareSignInfo';
import platform from "./platform";

var shareUrlFromFormat = function (orgUrl, fromParams) {
  var reg;
  var obj = {
    from: fromParams,
  };
  $.each(obj, function (paramName, replaceWith) {
    reg = new RegExp('(' + paramName + '=)([^&]*)', 'gi');
    var has = orgUrl.indexOf(paramName);

    if (has <= 0) {
      // 不存在改参数
      var hasQuestion = orgUrl.indexOf('?');
      if (hasQuestion > 0) {
        orgUrl = orgUrl + '&' + (paramName + '=' + replaceWith);
      } else {
        orgUrl = orgUrl + '?' + (paramName + '=' + replaceWith);
      }
    } else {
      // 存在该参数
      orgUrl = orgUrl.replace(reg, paramName + '=' + replaceWith);
    }
  });
  return orgUrl;
};

var wxScript;

//创建微信分享
var initShare = function (toWxData) {
  // 端内分享
  if (platform.isNfPlus) {
    nfplusShare(toWxData)
    return
  }

  if (platform.isQQ || platform.isQZ) {
    loadScript(['https://qzonestyle.gtimg.cn/qzone/qzact/common/share/share.js'], function () {
      window.setShareInfo({
        title: toWxData.title,
        summary: toWxData.desc, // 描述
        pic: toWxData.iconUrl,
        url: toWxData.shareUrl
      })
    })
    return
  }

  //获取微信公众号信息
  var sendAjax = function (data, sucFuc) {
    $.ajax({
      url: toWxShareUrl,
      type: 'get',
      dataType: 'json',
      cache: true,
      async: true,
      timeout: 60000,
      data: data,
      success: function (result) {
        sucFuc(result);
      },
      error: function (XMLHttpRequest, textStatus) {},
    });
  };
  // 获取发送数据
  var getWxData = function (toWxData) {
    var getWxSuc = function (result) {
      var getData = result.data;
      try {
        wxDoubleShare(getData, toWxData);
      } catch (e) {
        setTimeout(function () {
          wxDoubleShare(getData, toWxData);
        }, 300);
      }
    };
    var sendData = {};
    sendData.shareUrl = window.location.href.split('#')[0];
    sendAjax(sendData, getWxSuc);
  };

  getWxData(toWxData);
  return {
    getWxData: getWxData,
  };
};

function nfplusShare (o) {
    const options = {
      shareTitle: o.title,
      shareDesc: o.desc || '南方+创造更多价值',
      shareUrl: o.url || window.location.href,
      shareIcon: o.iconUrl
    }
    window.nfplusJsbridge.setShareInfo(options);

    if (window.nfplusJsbridge.updateAppMessageShareData) {
      window.nfplusJsbridge.updateAppMessageShareData({
        title: options.shareTitle,
        desc: options.shareDesc,
        imgUrl: options.shareIcon,
        link: options.shareUrl
      });
    }
}

//修改二次分享，getData后台传的数据，wxShareData分享的自定义数据
function wxDoubleShare(getData, wxShareData) {
  wx.config({
    debug: false,
    appId: getData.app_id,
    timestamp: getData.timestamp,
    nonceStr: getData.nonceStr,
    signature: getData.signature,
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone'],
  });
  wx.ready(function () {
    //分享到朋友圈
    wx.onMenuShareTimeline({
      title: wxShareData.title, //分享标题
      desc: wxShareData.desc, //分享描述
      link: shareUrlFromFormat(wxShareData.shareUrl || window.location.href, 'timeline'), //分享链接
      imgUrl: wxShareData.iconUrl, //分享图标
    });
    //分享给朋友
    wx.onMenuShareAppMessage({
      title: wxShareData.title, //分享标题
      desc: wxShareData.desc, //分享描述
      link: shareUrlFromFormat(wxShareData.shareUrl || window.location.href, 'weChatMessage'), //分享链接
      imgUrl: wxShareData.iconUrl, //分享图标
    });
    //分享到QQ
    wx.onMenuShareQQ({
      title: wxShareData.title, //分享标题
      desc: wxShareData.desc, //分享描述
      link: wxShareData.shareUrl, //分享链接
      imgUrl: wxShareData.iconUrl, //分享图标
    });
    //分享到腾讯微博
    wx.onMenuShareWeibo({
      title: wxShareData.title, //分享标题
      desc: wxShareData.desc, //分享描述
      link: wxShareData.shareUrl, //分享链接
      imgUrl: wxShareData.iconUrl, //分享图标
    });
    //分享到QQ空间
    wx.onMenuShareQZone({
      title: wxShareData.title, //分享标题
      desc: wxShareData.desc, //分享描述
      link: wxShareData.shareUrl, //分享链接
      imgUrl: wxShareData.iconUrl, //分享图标
    });
  });
}

export { initShare };



// WEBPACK FOOTER //
// ./src/js/shareWx.js